/**
 * @ngdoc controller
 * @name navigation.topnav.controllers:TopNavComponentController
 * @element
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .controller('TopNavComponentController', [
        '$rootScope',
        'NavService',
        '$scope',
        '$state',
        'Users',
        '$stateParams',
        'Acl',
        TopNavComponentController
    ]);

function TopNavComponentController($rootScope, NavService, $scope, $state, Users, $stateParams, Acl) {
    let vm = this;

    vm.topNavTree = [];
    vm.goToElem = goToElem;

    vm.customIframes = [];

    init();

    function init() {
        _updateNavTree();

        $rootScope.$on('al-nav-update-topnav', function () {
            _updateNavTree();
        })
    }

    function _updateNavTree() {
        NavService.getTopNavTree().then(topNavTree => {
            vm.topNavTree = topNavTree;
            _checkCustomIframes();
        }, e => {
            console.error('error while updating topNavTree', e);
        });
    }

    function goToElem(elem) {
        if(elem.action) {
            elem.action();
        } else {
            NavService.goToElem(elem.key, {});
        }
    }

    function _checkCustomIframes() {
        let customIFrames = _.get(Users.state, 'company.settings.core.custom_iframes', []);

        if(!_.isArray(customIFrames) || customIFrames.length === 0 || !Acl.hasRight('core::custom-iframes')) {
            return;
        }

        const newNavigation = {
            key: 'customs',
            label: 'Custom',
            active: ($state.current.name === 'app.core.custom-iframe'),
            order: 10000,
            action: () => {},
            children: _.map(customIFrames, (iframeInformation, index) => ({
                key: `custom-iframe-${iframeInformation.alias}`,
                label: iframeInformation.nav_label,
                active: ($state.current.name === 'app.core.custom-iframe' && $stateParams.iframeAlias === iframeInformation.alias),
                order: index,
                action: () => {
                    $state.go('app.core.custom-iframe', {
                        iframeAlias: iframeInformation.alias
                    });
                },
            }))
        };

        vm.topNavTree.push(newNavigation);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/components/topnav/controllers/component-controller.js